import { BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";
import { DocVisual } from "@/components/istituti/DocVisual";

const ROWS = [
  { id: "moduli", title: "Moduli flessibili", chips: ["Convenzione Quadro", "Progetto Formativo", "Sicurezza"], flip: false },
  { id: "privacy", title: "Privacy e Assicurazioni 100% a norma", chips: ["INAIL", "RC"], flip: true },
];

const Row = ({ id, title, chips, flip, n }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-24 items-center" data-testid={`burocrazia-row-${id}`}>
    <Reveal className={flip ? "lg:order-2" : ""}>
      <span className="text-xs tracking-[0.25em] text-titanium">{n}</span>
      <h3 className="mt-4 font-extrabold tracking-[-0.035em] leading-[1.08] text-3xl sm:text-4xl max-w-[18ch]">{title}</h3>
      <div className="mt-8 flex flex-wrap gap-3">
        {chips.map((c) => (
          <span key={c} className="glass rounded-full px-4 py-2 text-sm text-white/90">
            {c}
          </span>
        ))}
      </div>
    </Reveal>
    <Reveal delay={150} className={`max-w-[520px] w-full ${flip ? "lg:order-1" : "lg:ml-auto"}`}>
      <DocVisual variant={id} />
    </Reveal>
  </div>
);

export const Burocrazia = () => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="istituti-burocrazia-section">
    <div className="max-w-7xl mx-auto">
      <Reveal className="mb-16 lg:mb-28">
        <Eyebrow className="mb-6">Burocrazia Azzerata</Eyebrow>
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1.02] text-4xl sm:text-5xl lg:text-6xl max-w-[18ch]">
          Documenti pronti, tutele garantite.
        </h2>
      </Reveal>
      <div className="space-y-24 lg:space-y-36">
        {ROWS.map(({ id, ...r }, i) => (
          <Row key={id} id={id} {...r} n={`0${i + 1}`} />
        ))}
        <Reveal>
          <div
            className="glass rounded-[28px] shadow-[0_0_40px_rgba(0,229,255,0.12)] px-8 py-14 sm:py-20 text-center"
            style={{ borderColor: "rgba(0, 229, 255, 0.35)" }}
            data-testid="burocrazia-gratuito-badge"
          >
            <BadgeCheck className="mx-auto h-8 w-8 text-cyan" strokeWidth={1.4} />
            <p className="mt-6 font-extrabold tracking-[-0.04em] leading-[1.05] text-3xl sm:text-5xl lg:text-6xl">
              100% gratuito <span className="text-titanium">e senza vincoli</span>
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
